import { useMe } from "@/context/user-context";

export function useUserRole() {
  const { user } = useMe();

  return user.role;
}
